import flowRight from 'lodash/flowRight';
import NP from 'number-precision';
import millify from 'millify';
import { INVALID } from '../constant';

// add a comma every three digit: https://stackoverflow.com/a/2901298/4141628
// export const addComma = (v: string) => v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

// const addDollarUnit = (v: string) => `$${v}`;
const roundWithAtMostTwoDecimals = (v: number) => NP.round(v, 2);

const fixedTwoDigital = (v: number) => v.toFixed(2);

const isValid = (v: number | undefined | null) => v != null && !Number.isNaN(v) && v <= Number.MAX_SAFE_INTEGER;

const formatNumberWithTwoDigital = flowRight(fixedTwoDigital, roundWithAtMostTwoDecimals);

// export const currencyFormat = (v: number | undefined | null) =>
//   isValid(v) ? flowRight(addDollarUnit, addComma, formatNumberWithTwoDigital)(<number>v) : INVALID;

export const percentNumberFormat = (v: number | undefined | null) =>
  isValid(v) ? `${formatNumberWithTwoDigital(<number>v)}%` : INVALID;

export const numberMillify = (number: number | undefined | null) => {
  return isValid(number) ? millify(<number>number) : INVALID;
};
